export enum UpdateProfileStepsEnum {
    PersonalDetails = 'Personal details',
    PostalAddress = 'Postal address',
    LocationAndPreferences = 'Location & preferences',
    PcsDetails = 'PCS details',
    WorkDetails = 'Work details'
}